import React, { Component } from "react";
import { connect } from "react-redux";
import ReactTable from 'react-table';
import swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import withFixedColumns from "react-table-hoc-fixed-columns";

import { addMap, getMaps, getWorkspace, updateMap, updateWorkspace } from "../../../../store/actions/promotersActions";

import './PromotersPromoterMaps.sass';
import { AddMapModal } from "./AddMapModal";
import { EditMapActions } from "./EditMapActions";
import { EditNameModal } from "./EditNameModal";
import NewLoader from "../../../../components/NewLoader/NewLoader";

const MySwal = withReactContent(swal);

const ReactTableFixedColumns = withFixedColumns(ReactTable);

class PromotersPromoterMaps extends Component {
  state = {
    maps: [],
    workspace: {},
    newMapData: {
      name: '',
      publicChartKey: '',
      hideChartKey: '',
    },
    isSaveDisabled: true,
    isDataLoading: true,
  };

  openAddMapForm = () => {
    const { workspace } = this.state;
    if (
      !workspace.name ||
      !workspace.publicPublicWorkspaceKey ||
      !workspace.publicSecretWorkspaceKey ||
      !workspace.hidePublicWorkspaceKey ||
      !workspace.hideSecretWorkspaceKey
    ) {
      MySwal.fire({
        title: "Empty workspace",
        text: "Fill in and save the workspace data to add a map",
      });
      return;
    };

    MySwal.fire({
      title: 'Map form',
      html: (
        <AddMapModal
          addMap={this.addMap}
        />
      ),
      width: '600px',
      showConfirmButton: false,
    });
  };

  addMap = (data) => {
    const token = this.props.user.token;
    const id = this.props.match.params.promoterId;

    this.props.addMap(token, id, data)
      .then(() => MySwal.close())
      .then(() => this.props.getMaps(token, id))
      .then((maps) => this.setState({ maps }));
  };

  handleChangeWorkspaceData = (e) => {
    const { name, value } = e.target;
    
    const { ...workspace } = this.state.workspace;
    workspace[name] = value;

    this.setState({ workspace, isSaveDisabled: false });
  };

  editMap = (map, key, value) => {
    const token = this.props.user.token;
    const id = this.props.match.params.promoterId;

    const data = {
      ...map,
      [key]: value,
    };

    this.props.updateMap(token, id, data)
      .then(() => this.props.getMaps(token, id))
      .then((maps) => this.setState({ maps }));
  };

  updateWorkspace = () => {
    const token = this.props.user.token;
    const id = this.props.match.params.promoterId;

    this.props.updateWorkspace(token, id, this.state.workspace)
      .then(() => this.setState({ isSaveDisabled: true }));
  };

  handleChangeMapName = (map) => {
    MySwal.fire({
      title: 'Change name',
      html: (
        <EditNameModal
          map={map}
          editMap={this.editMap}
        />
      ),
      width: '600px',
      showConfirmButton: false,
    });
  };

  componentDidMount() {
    const token = this.props.user.token;
    const id = this.props.match.params.promoterId;

    Promise.all([this.props.getMaps(token, id), this.props.getWorkspace(token, id)])
      .then(([maps, workspace]) => {
        this.setState((state) => {
          return {
            maps: maps || [],
            workspace: workspace || state.workspace,
            isDataLoading: false,
          }
        });
      })
  }

  render() {
    const { maps, workspace, isSaveDisabled, isDataLoading } = this.state;

    const getFlexStyle = (e) => ({
      style: {
        padding: "3px 2px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end"
      },
    });

    const columns = [
      {
        Header: 'Map name',
        accessor: 'name',
        resizable: false,
      },
      {
        Header: 'Public chart key',
        accessor: 'publicChartKey',
        resizable: false,
      },
      {
        Header: 'Hidden chart key',
        accessor: 'hideChartKey',
        resizable: false,
      },
      {
        Header: 'Status',
        resizable: false,
        width: 120,
        Cell: ({
          row: {
            _original: { archived },
          },
        }) => {
          if (archived) {
            return (
              <div className={`status-label status-label--archived`}>
                Archived
              </div>
            )
          };
          return (
            <div className={`status-label status-label--active`}>
              Active
            </div>
          )
        },
      },
      {
        Cell: ({ row: { _original } }) => (
          <EditMapActions map={_original} editMap={this.editMap} handleChangeMapName={this.handleChangeMapName} />
        ),
        getProps: getFlexStyle,
        width: 60,
        fixed: "right",
      },
    ];

    if (isDataLoading) {
      return (
        <div className='promoters-promoter__loader'>
          <NewLoader />
        </div>
      )
    }
    
    return (
      <div className="promoter-maps">
        <div className="promoter-maps__main">
          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Workspace name</label>

                <input
                  type="text"
                  name="name"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter workspace name"
                  value={workspace.name}
                  onChange={this.handleChangeWorkspaceData}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>Visible public workspace key</label>
                <input
                  type="text"
                  name="publicPublicWorkspaceKey"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter workspace name"
                  value={workspace.publicPublicWorkspaceKey}
                  onChange={this.handleChangeWorkspaceData}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>Visible secret workspace key</label>

                <input
                  type="text"
                  name="publicSecretWorkspaceKey"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter workspace name"
                  value={workspace.publicSecretWorkspaceKey}
                  onChange={this.handleChangeWorkspaceData}
                />
              </div>
            </div>
          </div>

          <div className="add-event__row">
            <div className="add-event__column">
              <div className="add-event__block">
                <label>Hidden public workspace key</label>

                <input
                  type="text"
                  name="hidePublicWorkspaceKey"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter workspace name"
                  value={workspace.hidePublicWorkspaceKey}
                  onChange={this.handleChangeWorkspaceData}
                />
              </div>
            </div>

            <div className="add-event__column">
              <div className="add-event__block">
                <label>Hidden secret workspace key</label>

                <input
                  type="text"
                  name="hideSecretWorkspaceKey"
                  minLength="3"
                  maxLength="500"
                  placeholder="Enter workspace name"
                  value={workspace.hideSecretWorkspaceKey}
                  onChange={this.handleChangeWorkspaceData}
                />
              </div>
            </div>
          </div>

          <div className="promoter-maps__table-block">
            {!maps.length ? (
              <div></div>
            ) : (
              <ReactTableFixedColumns
                data={maps}
                columns={columns}
                showPagination={false}
                minRows={0}
                sortable={false}
                defaultPageSize={9999999}
              />
            )}
          </div>
        </div>
        <div className="promoter-maps__actions">
          <button
            type="button"
            className="btn-primary btn-primary--save"
            onClick={this.openAddMapForm}
          >
            <span>Add map</span>
          </button>

          <button
            type="button"
            className="btn-primary btn-primary--save"
            onClick={this.updateWorkspace}
            disabled={
              isSaveDisabled ||
              !workspace.name ||
              !workspace.publicPublicWorkspaceKey ||
              !workspace.publicSecretWorkspaceKey ||
              !workspace.hidePublicWorkspaceKey ||
              !workspace.hideSecretWorkspaceKey
            }
          >
            <span>Save workspace</span>
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({
  auth: { user },
  promoters: { loading, maps, workspace }
}) => ({ user, loading, maps, workspace });

const mapDispatchToProps = (dispatch) => ({
  getMaps: (token, id) => dispatch(getMaps(token, id)),
  addMap: (token, id, data) => dispatch(addMap(token, id, data)),
  getWorkspace: (token, id) => dispatch(getWorkspace(token, id)),
  updateWorkspace: (token, id, data) => dispatch(updateWorkspace(token, id, data)),
  updateMap: (token, id, data) => dispatch(updateMap(token, id, data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PromotersPromoterMaps);